import { useState, useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function WeightLossConsentForm({
  clinic,
  patient,
  sigPad,
  signature,
  viewOnly,
  date,
}) {
  useEffect(() => {
    if (viewOnly) {
      sigPad.current.fromData(signature);
    }
  }, [viewOnly]);

  return (
    <div className="rounded-lg overflow-hidden">
      <div className="p-6 max-w-4xl mx-auto ">
        <h1 className="text-3xl font-bold text-center mb-6">
          Weight Loss Program Consent Form
        </h1>

        <div className="space-y-4 mb-6 text-gray-800">
          <p>
            I,{" "}
            <span className="inline-block min-w-[250px] sm:min-w-[350px] border-b-2 border-black border-dashed text-center">
              {patient.lastname} {patient.firstname}
            </span>
            , authorize {clinic.name} and whoever is designated as this clinic's
            assistant, to help me in my weight reduction efforts. I understand
            that my program may consist of a balanced-deficit diet, a regular
            exercise program, instruction on behavior modification techniques,
            and may involve the use of weight management medications. Other
            treatment options may include a very low-calorie diet, or a
            protein-supplemented diet.
          </p>

          <p>
            I further understand that if medications are used, they may be used
            for durations exceeding those recommended in the medication package
            insert. It has been explained to me that these medications have been
            used safely and successfully in private medical practices as well as
            in academic centers for periods exceeding those recommended in the
            product literature.
          </p>

          <p>
            I understand that any medical treatment may involve risks as well as
            the proposed benefits. I also understand that there are certain
            health risks associated with remaining overweight or obese. Risks of
            this program may include but are not limited to:
          </p>

          <ul className="list-disc pl-6 space-y-2">
            <li>
              nervousness, sleeplessness, headaches, dry mouth, gastrointestinal
              disturbances, weakness, tiredness, psychological problems
            </li>
            <li>
              high blood pressure, rapid heartbeat, and heart irregularities
            </li>
            <li>
              risk of serious or fatal health complications for those who are
              significantly overweight
            </li>
            <li>
              potential increased risk of high blood pressure, diabetes, heart
              attack, heart disease, arthritis of the joints
            </li>
            <li>sleep apnea, and sudden death</li>
          </ul>

          <p>
            I understand that these risks may be modest if I am not
            significantly overweight but will increase with additional weight
            gain. I understand that much of the success of the program will
            depend on my efforts and that there are no guarantees or assurances
            that the program will be successful.
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Patient Name:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {`${patient.lastname} ${patient.firstname}`}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Date:</p>
          <p className="border py-4 px-4 rounded-md text-sm">
            {viewOnly
              ? new Date(date).toLocaleDateString()
              : new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="mb-4">
          <p className="block mb-1 text-gray-700">Signature:</p>
          <div className="border rounded-md p-2">
            <SignatureCanvas
              ref={sigPad}
              canvasProps={{
                className: `signature-canvas w-full h-40 bg-white ${
                  viewOnly ? "pointer-events-none" : ""
                }`,
              }}
            />
          </div>
        </div>

        <p className="text-sm text-gray-800 my-2">
          If you have any questions regarding the risks or hazards of the
          proposed treatment, or any questions concerning the proposed treatment
          or other possible treatments, ask your doctor now before signing this
          consent form
        </p>
      </div>
    </div>
  );
}
